import React from 'react';
import PropTypes from 'prop-types';
import {Form} from 'react-bootstrap';

export default function CustomSwitch(props) {
  const {value, ...filteredProps} = props
  // Forms may hold '' as "not set yet" (e.g. hasHeader before a CSV is parsed):
  // a switch is a boolean control, so anything but `true` renders unchecked.
  return <Form.Switch {...filteredProps} checked={value === true} style={{display: 'inline-block'}}/>
}

CustomSwitch.propTypes = {
  value: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf([''])]).isRequired
}
